<template>
    <div>
            <v-tabs v-model="activeTab" background-color="transparent" class="mb-4">
                <v-tab>Algemeen</v-tab>
                <v-tab>Weergave</v-tab>
                <v-tab>Data verwerking</v-tab>
                <v-tab>Asset types</v-tab>
            </v-tabs>
        <v-tabs-items :value="activeTab">
            <v-tab-item transition="transition-fade">
                <v-row>
                    <v-col cols="12" lg="8">
                <eod-card class="mb-4 pt-2">
                    <v-card-text>
                <v-row>
                    <v-col>
                        <eod-text-field translatable :value="value.name" @input="val => updateProperty({name:val})" :rules="[val => rules.required(val, 'Naam')]" label="Naam*" required></eod-text-field>
                    </v-col>
                    <v-col>
                        <eod-listitem-autocomplete outlined dense hide-details
                            v-if="$eod.getOrganizationSetting('measurementTypes.units.listId')"
                            :prependItems="[{ id: null, name: 'Geen' }]" v-model="value.unit" label="Eenheid"
                            :returnObject="true"
                            :listId="$eod.getOrganizationSetting('measurementTypes.units.listId').value"></eod-listitem-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <eod-textarea :value="value.description" @input="val => updateProperty({description:val})" label="Omschrijving" rows="3" translatable info="Extra informatie die op het formulier of dashboard kan worden weergegeven"></eod-textarea>
                    </v-col>
                </v-row>
                <v-row>
                        <v-col>
                            <eod-autocomplete :items="settings.fieldTypes" label="Type*" :value="itemType" @input="val => updateProperty({formConfig:{type:val}})" item-value="value" item-text="text" :rules="[val => rules.required(val, 'Type')]" @change="fieldTypeChanged">
                                <template v-slot:item="{item, on, attrs}">
                                    <v-list-item v-on="on" v-bind="attrs">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ item.info }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </eod-autocomplete>
                        </v-col>
                        <v-col v-if="listTypes.includes(itemType)">
                            <div class="d-flex align-center">
                                <eod-object-autocomplete hide-details label="Bestaande lijst" :value="value.valueConfigList" @input="changeListItems" endpoint="lists" return-object :fields="['id', 'name', 'measurementTypes{id}', 'itemType', 'listItems{id name, threshold, color}']"></eod-object-autocomplete>
                                <v-btn class="ml-2" small depressed color="primary" rounded @click="createNewList"><v-icon left small>mdi-plus</v-icon>Nieuwe lijst</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row v-if="['number'].includes(itemType)">
                        <v-col><eod-text-field type="number" step="0.01" :value="value.typeConfig.min" @input="val => updateProperty({typeConfig:{min: val}})" label="Min" clearable></eod-text-field></v-col>
                        <v-col><eod-text-field type="number" step="0.01" :value="value.typeConfig.max" @input="val => updateProperty({typeConfig:{max: val}})" label="Max" clearable></eod-text-field></v-col>
                    </v-row>
                    <v-row v-else-if="['table'].includes(itemType)">
                        <v-col>
                            <eod-measurement-type-columns :value="value.formConfig.columns" @input="updateColumns"></eod-measurement-type-columns>
                        </v-col>
                    </v-row>
                    <div v-if="listTypes.includes(itemType)" class="mt-4">
                        <div v-if="listItems">
                            <v-alert v-if="listLinkCount > 0" type="info" text dense class="mb-4">
                                <div class="d-flex align-center flex-wrap" style="gap:8px">
                                    <div>Deze lijst is ook gekoppeld aan {{ listLinkCount }} andere meetwaarde(n). Wijzigingen aan de lijst en de opties worden ook daar toegepast.</div>
                                    <v-spacer></v-spacer>
                                    <v-btn small depressed rounded color="info" @click="duplicateList"><v-icon left small>mdi-content-copy</v-icon>Lijst dupliceren</v-btn>
                                </div>
                            </v-alert>
                            <eod-text-field class="mb-2" label="Naam van de lijst" :value="value.valueConfigList ? value.valueConfigList.name : null" @input="updateListName"></eod-text-field>
                            <v-list dense>
                                <v-list-item v-for="(item, index) in visibleListitems()" :key="'listItem_'+index">
                                    <v-list-item-content class="py-1">
                                        <v-row dense align="center" class="mt-1" >
                                            <v-col cols="12" sm="3">
                                                <eod-text-field type="number" step="0.01" label="Waarde" hide-details v-model.number="item.threshold"></eod-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <eod-text-field label="Naam" hide-details v-model="item.name"></eod-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <eod-color-picker label="Kleur" hide-details v-model="item.color" dot-size="15" hide-mode-switch mode="hex"></eod-color-picker>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-content>
                                    <v-btn @click="deleteListItem(item)" class="mt-1" icon color="error"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                                </v-list-item>
                            </v-list>
                            <v-btn @click="addListItem" color="primary" dense rounded small class="mt-4"><v-icon small>mdi-plus</v-icon>Optie toevoegen</v-btn>
                        </div>
                    </div>
            </v-card-text>
        </eod-card>
    </v-col>
        <v-col cols="12" lg="4">
            <eod-card title="Formulier">
                <v-card-text :key="updateFormConfigKey">
                    <v-card outlined>
                        <v-card-text>
                            <v-switch class="mt-0" hide-details :input-value="value.formConfig.enabled" @change="val => updateFormConfig('enabled', val)"
                                label="Zichtbaar"></v-switch>
                        </v-card-text>
                        <div v-if="value.formConfig.enabled" class="grey lighten-4 px-4 py-2">
                            <v-switch hide-details class="mt-0" :input-value="value.formConfig.required" @change="val => updateFormConfig('required', val)" label="Verplicht"></v-switch>
                        </div>
                    </v-card>
                        <v-card v-if="value.formConfig.enabled" outlined class="mt-4">
                                <v-card-text>
                                    <v-switch class="mt-0" hide-details :input-value="value.formConfig.photo" @change="val => updateFormConfig('photo', val)"
                                        label="Foto toevoegen mogelijk"></v-switch>
                                </v-card-text>

                                <div v-if="value.formConfig.photo" class="grey lighten-4 px-4 py-2">
                                    <v-switch hide-details class="mt-0" :input-value="value.formConfig.photoRequired" @change="val => updateFormConfig('photoRequired', val)"
                                        label="Foto toevoegen verplicht"></v-switch>
                                    <v-text-field class="mt-4" dense outlined hide-details="auto" type="number" min="1" step="1" clearable
                                        :value="value.formConfig.photoMax" @change="updatePhotoMax" @click:clear="updatePhotoMax(null)" :rules="[val => !val || parseInt(val) >= 1 || 'Minstens 1']"
                                        label="Maximum aantal foto's" hint="Optioneel. De app waarschuwt bij meer foto's, maar laat ze wel toe." persistent-hint></v-text-field>
                                </div>
                            </v-card>
                            <v-card v-if="value.formConfig.enabled" outlined class="mt-4">
                                <v-card-text>
                                    <v-switch class="mt-0" hide-details :input-value="value.formConfig.comment" @change="val => updateFormConfig('comment', val)"
                                        label="Commentaar toevoegen mogelijk"></v-switch>
                                </v-card-text>

                                <div v-if="value.formConfig.comment" class="grey lighten-4 px-4 py-2">
                                    <v-switch hide-details class="mt-0" :input-value="value.formConfig.commentRequired" @change="val => updateFormConfig('commentRequired', val)"
                                        label="Commentaar toevoegen verplicht"></v-switch>
                                </div>
                            </v-card>
                </v-card-text>
            </eod-card>
            <eod-card class="mt-4" title="Koppeling">
                                            <div class="px-4 pb-4">
                                        <eod-integration-ids :key="'integration_ids'+value.id" v-if="value.id" :itemId="value.id" endpoint="measurementTypes"></eod-integration-ids>
                                        <v-alert v-else type="info" text>Gelieve eerst te bewaren om integratie ID's te koppelen</v-alert>
                                    </div>
                                    </eod-card>
        </v-col>
        </v-row>
            </v-tab-item>
            <v-tab-item transition="transition-fade">
                <p>
                    <v-icon left>mdi-information</v-icon>Standaard weergave om automatisch een dashboard te genereren.
                </p>
                <eod-card>
                    <v-card-text>
                <v-row>
                    <v-col>
                        <eod-color-picker info="Standaard kleur om deze meetwaarde te visualiseren, merk op dat dit kan overschreven worden door de kleur ingesteld op een asset of dashboard tegel" label="Kleur" v-model="value.color" dot-size="15" hide-mode-switch mode="hexa"></eod-color-picker>
                    </v-col>
                    <v-col>
                        <eod-icon-picker info="Icoon om de meetwaarde weer te geven op een dashboard tegel" dense outlined label="Icoon" v-model="value.icon"></eod-icon-picker>
                    </v-col>
                </v-row>
                <v-item-group v-model="value.dashboardConfig.graphs" multiple>
            <v-row class="mt-4">
                <v-col cols="12" md="6" lg="3" xl="2" v-for="type in cellTypes" :key="type.key">
                    <v-item v-slot="{ active, toggle }"  :value="type.key">
                    <eod-card :color="active?'secondary':null" @click="toggle" outlined>
                        <template v-slot:header>
                            <v-card-title class="py-2">
                            <v-avatar size="40"  class="mr-2">
                                <eod-icon :class="{'primary--text':!active, 'white--text':active}" size="30">{{ type.icon }}</eod-icon>
                            </v-avatar>
                            <div class="text-body-1" :class="{'white--text':active}">
                                {{ type.title }}
                            </div>
                            <v-spacer></v-spacer>
                            <v-tooltip top v-if="type.info">
                                <template v-slot:activator="{attrs, on}">
                                    <v-btn :dark="active" icon v-bind="attrs" v-on="on"><v-icon>mdi-information-outline</v-icon></v-btn>
                                </template>
                                {{ type.info }}
                            </v-tooltip>
                        </v-card-title>
                        </template>
                        
                    </eod-card>
                </v-item>
                <eod-card v-if="value.dashboardConfig.graphs.includes(type.key) && type.key == 'tile'" outlined class="grey lighten-4 px-4 py-1">
                    <v-switch class="mt-0" hide-details v-model="value.isWritable" :true-value="true" :false-value="false" label="Meetwaarde kan worden ingesteld via het dashboard"></v-switch>
                </eod-card>
            </v-col>
        </v-row>
    </v-item-group>
            </v-card-text>
            </eod-card>
            </v-tab-item>
            <v-tab-item transition="transition-fade">
                <p>
                    <v-icon left>mdi-information</v-icon>Instellingen om de data die via een IoT gateway wordt ontvangen te verwerken. Merk op dat dit de standaard instellingen voor deze meetwaarde zijn, deze kunnen eventueel per dataconnector worden overschreven.
                </p>
                <eod-card>
                    <v-card-text>
                <v-row>
                    <v-col>
                        <eod-text-field info="Naam waarmee de data zal worden verstuurd door de IoT gateway naar de EoD broker vb. water_level_counter_1" outlined dense hide-details label="HardwareId" :value="getMetricValue('hardwareId')"
                            @input="val => setMetricValue('hardwareId', val)"></eod-text-field>
                    </v-col>
                    <!-- <v-col>
                        <v-autocomplete outlined dense hide-details label="dataType"
                            :items="MeasurementType.Metric_DataTypes" :value="getMetricValue('dataType')"
                            @input="val => setMetricValue('dataType', val)"></v-autocomplete>
                    </v-col> -->
                </v-row>
                <v-row>
                    <v-col><eod-text-field info="Een getal waarmee de ontvangen waarde dient vermenigvuldigd te worden voor deze in EoD wordt verwerkt vb. 0.1 zal de ontvangen waarde 10 omzetten naar 1, 100 zal de ontvangen waarde 10 omzetten naar 1000" type="number" step="0.1" outlined dense hide-details label="Factor"
                            :value="getMetricValue('factor')"
                            @input="val => setMetricValue('factor', val)"></eod-text-field></v-col>
                    <v-col><eod-text-field info="Een getal waarmee de ontvangen waarde dient opgeteld te worden voor deze in EoD wordt verwerkt om bijvoorbeeld de beginstand van een teller in rekening te brengen vb. 50 zal de ontvangen waarde 5 omzetten naar waarde 55, -100 zal de ontvangen waarde 2000 omzetten naar 1900" type="number" step="0.1" outlined dense hide-details label="Offset"
                            :value="getMetricValue('offset')"
                            @input="val => setMetricValue('offset', val)"></eod-text-field></v-col>
                    <v-col><eod-text-field info="Het data collectie interval in seconden" type="number" step="1" outlined dense hide-details label="Interval"
                            :value="getMetricValue('interval')"
                            @input="val => setMetricValue('interval', val)"></eod-text-field></v-col>
                </v-row>
                <v-row>
                    <v-col><eod-autocomplete outlined dense hide-details label="Methode"
                            :items="MeasurementType.Metric_Methods" :value="getMetricValue('method')"
                            @input="val => setMetricValue('method', val)">
                        <template v-slot:item="{item, on, attrs}">
                            <v-list-item v-bind="attrs" v-on="on">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ item.info }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        </eod-autocomplete></v-col>
                </v-row>
            </v-card-text>
            </eod-card>
            <p class="mt-6">
                <v-icon left>mdi-information</v-icon>Een afgeleide meetwaarde wordt berekend op het moment dat de bronmeting binnenkomt: <strong>bron × factor + instelling op het asset</strong>. De instelling (bv. installatiediepte) staat op het asset onder het instellingsmeetwaardetype, met een geldigheid van/tot. Een later gewijzigde instelling geldt vanaf dan; eerdere waarden blijven zoals ze berekend werden.
            </p>
            <eod-card>
                <v-card-title class="text-body-1 pb-2">Berekend uit</v-card-title>
                <v-card-text>
                <v-row>
                    <v-col cols="12" md="5">
                        <eod-object-autocomplete outlined dense hide-details label="Bronmeetwaardetype" info="Het meetwaardetype waarvan de opgeslagen waarde de bron is, bv. Gemeten waterpeil" endpoint="measurementTypes" return-object :exclude="value.id ? [{id: value.id}] : []" :value="value.sourceMeasurementType || null" @input="val => updateDerived('sourceMeasurementType', val)" clearable></eod-object-autocomplete>
                    </v-col>
                    <v-col cols="12" md="5">
                        <eod-object-autocomplete outlined dense hide-details label="Instellingsmeetwaardetype" info="Het meetwaardetype waaronder de instelling op het asset staat (tab Instellingen van het asset), bv. Diepte sensor t.o.v. bovenkant peilbuis" endpoint="measurementTypes" return-object :exclude="value.id ? [{id: value.id}] : []" :value="value.settingMeasurementType || null" @input="val => updateDerived('settingMeasurementType', val)" clearable></eod-object-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2">
                        <eod-text-field info="Vermenigvuldiger op de bronwaarde, standaard 1. Negatief om een afstand om te zetten in een peil." type="number" step="0.001" outlined dense hide-details label="Factor" :value="value.factor == null ? 1 : value.factor" @input="val => updateDerived('factor', val)"></eod-text-field>
                    </v-col>
                </v-row>
                <v-alert v-if="(value.sourceMeasurementType && !value.settingMeasurementType) || (!value.sourceMeasurementType && value.settingMeasurementType)" type="warning" text dense class="mb-0 mt-4">Kies zowel een bronmeetwaardetype als een instellingsmeetwaardetype, of geen van beide.</v-alert>
                </v-card-text>
            </eod-card>
            </v-tab-item>
            <v-tab-item>
                <eod-product-types-indicative :value="value.productTypes" @input="val => updateProperty({productTypes:val})"></eod-product-types-indicative>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import { MeasurementType } from './../models';
import eodIconPicker from './eod-icon-picker.vue';
import eodListItems from './eod-list-items.vue';
import eodIntegrationIds from './eod-integration-ids.vue';
import { CELL_GROUPS } from './../models/dashboard';
import eodTranslations from './eod-translations.vue';
import eodListItemAutocomplete from './eod-list-item-autocomplete.vue';
import eodObjectAutocomplete from './eod-object-autocomplete.vue';
import eodColorPicker from './eod-color-picker.vue';
import eodProductTypesIndicative from './eod-productTypes-indicative.vue';
import eodMeasurementTypeColumns from './eod-measurementType-columns.vue';

export default {
    name: 'eod-measurementType',
    components: {
        eodListItems,
        eodTranslations,
        'eod-listitem-autocomplete': eodListItemAutocomplete,
        eodObjectAutocomplete,
        eodColorPicker,
        eodIconPicker,
        eodIntegrationIds,
        eodProductTypesIndicative,
        'eod-measurement-type-columns': eodMeasurementTypeColumns
    },
    props: {
        value: Object
    },
    data: () => {
        return {
            MeasurementType: MeasurementType,
            saving: false,
            settings: require('@/classes/settings.js'),
            rules: {
                required: (value, fieldName) => !!value || (fieldName?fieldName:'Veld')+' is verplicht.',
            },
            listTypes: ['scale'],
            visibleDashboardCellTypes: [],
            listItems: null,
            listLinkCount: 0,
            activeTab:0,
            itemType: 'number',
            cellTypes: CELL_GROUPS.graphs.cellTypes,
            updateFormConfigKey: 98343
        }
    },
    created() {
        let val = this.value;
        if (!val.dashboardConfig) {
            val.dashboardConfig = {
                graphs: ['tile']
            };
        }
        if (!Array.isArray(val.dashboardConfig.graphs)) {
            val.dashboardConfig.graphs = ['tile'];
        }

        if(!val.typeConfig){
            val.typeConfig = {}
        }

        if (!val.metricConfig) {
            val.metricConfig = {
                dataType: 'FLOAT',
                factor: 1,
                offset: 0,
                interval:900,
                method:'POLLED'
            };
        }

        if (!val.id) {
            val.unit = {
                id: null
            }
            val.formConfig = {
                enabled: true,
                type: 'number',
                photo: true,
                comment: true
            }
        }

        // Een bestaand meetwaardetype zonder formConfig (bv. aangemaakt via de API): de template
        // leest value.formConfig.enabled, dus zonder object crasht de render.
        if (!val.formConfig) {
            val.formConfig = {};
        }

        if(val.formConfig && val.formConfig.type){
            this.itemType = val.formConfig.type;
        }

        if(val.valueConfigList){
            this.changeListItems(val.valueConfigList);
        }

        this.$emit('input', val);
    },
    watch: {
        // Na een save vervangt de detail-view value.valueConfigList door de bewaarde
        // versie (met de door de backend toegekende id's). Neem de nieuwe items-array
        // over, anders bewerkt de component verder op de stale array zonder id's en
        // ontstaan er duplicaten bij een volgende save. Bewust geen changeListItems():
        // dat emit opnieuw input en zou listLinkCount resetten (de bewaarde lijst
        // bevat geen measurementTypes-selectie).
        'value.valueConfigList'(val) {
            if (!val) {
                this.listItems = null;
            } else if (val.listItems && val.listItems !== this.listItems) {
                this.listItems = val.listItems;
            }
        },
    },
    methods: {
        updateFormConfig(propertyName, value){
            let val = this.value;
            val.formConfig[propertyName] = value;
            this.$emit('input', val);
            this.updateFormConfigKey++;
        },
        updatePhotoMax(value){
            // Leeg = geen limiet. Anders een geheel getal >= 1; ongeldige invoer wordt genegeerd.
            const photoMax = parseInt(value);
            this.updateFormConfig('photoMax', photoMax >= 1 ? photoMax : null);
        },
        updateProperty(data){
            let val = this.value;
            val = _.merge(val, data);
            this.$emit('input', val);
        },
        updateColumns(columns){
            const val = this.value;
            this.$set(val.formConfig, 'columns', columns);
            this.$emit('input', val);
            this.$forceUpdate();
        },
        visibleListitems(){
            const items = [];
            for (let i = 0; i < this.listItems.length; i++) {
                const listItem = this.listItems[i];
                if(!listItem.isDeleted){
                    items.push(listItem);
                }
            }
            return items;
        },
        deleteListItem(item){
            const val = this.value;

            const index = this.listItems.indexOf(item);
            if(index < 0){
                return;
            }

            if(this.listItems[index].id){
                this.$set(this.listItems[index], 'isDeleted', true);
            }else{
                this.listItems.splice(index, 1);
            }

            val.valueConfigList.listItems = this.listItems;

            this.$emit('input', val);
            this.$forceUpdate();
        },
        createNewList(){
            const val = this.value;
            val.valueConfigList = {
                name: val.name || null,
                itemType:'VALUE_TO_TEXT',
                listItems: [
                    {
                        threshold: 1,
                        name: null,
                        color: null
                    }
                ]
            }
            this.listLinkCount = 0;
            this.changeListItems(val.valueConfigList);
            this.$emit('input', val);
        },
        updateListName(name){
            const val = this.value;
            if(!val.valueConfigList){
                return;
            }
            this.$set(val.valueConfigList, 'name', name);
            this.$emit('input', val);
        },
        duplicateList(){
            const val = this.value;
            if(!val.valueConfigList){
                return;
            }

            // Maak een kopie van de lijst zonder id's zodat bij het bewaren een
            // nieuwe lijst wordt aangemaakt die enkel aan deze meetwaarde is gekoppeld.
            const items = this.visibleListitems().map(item => {
                const copy = Object.assign({}, item);
                delete copy.id;
                delete copy.isDeleted;
                return copy;
            });

            const newList = {
                name: val.valueConfigList.name ? val.valueConfigList.name + ' (kopie)' : (val.name || null),
                itemType: val.valueConfigList.itemType,
                listItems: items
            };

            val.valueConfigList = newList;
            this.listLinkCount = 0;
            this.changeListItems(newList);
            this.$emit('input', val);
        },
        addListItem(){
            // Get next value
            const val = this.value;
            let max = 0;
            for (let i = 0; i < this.listItems.length; i++) {
                const listItem = this.listItems[i];
                if(listItem.threshold > max){
                    max = listItem.threshold;
                }
            }

            this.listItems.push({
                threshold: max+1,
                name:'',
                color: null
            });

            val.valueConfigList.listItems = this.listItems;
            this.$emit('input', val);
            this.$forceUpdate();
        },
        fieldTypeChanged(fieldType){
            this.itemType = fieldType
            const val = this.value;
                val.valueConfigList = null;
                this.listLinkCount = 0;
                if(fieldType == 'table' && !val.formConfig.columns){
                    this.$set(val.formConfig, 'columns', []);
                }
                this.$emit('input', val);
        },
        changeListItems(val){
            this.listItems = null;
            if(val && val.listItems){
                this.listItems = val.listItems;
            }

            this.updateProperty({valueConfigList:val});
            this.checkListLinks(val ? val : null);
        },
        async checkListLinks(list){
            this.listLinkCount = 0;
            if(!list){
                return;
            }

            if(list.measurementTypes){
                this.listLinkCount =  list.measurementTypes.filter(item => item.id != this.value?.id).length;
            }
        },
        updateDerived(propertyName, val) {
            // Geen _.merge: een object vervangen (of leegmaken) moet de oude relatie volledig loslaten.
            const item = this.value;
            this.$set(item, propertyName, val === undefined || val === '' ? null : val);
            this.$emit('input', item);
        },
        setMetricValue(propertyName, val) {
            const item = this.value;

            item.metricConfig[propertyName] = val;

            this.$emit('input', item);
        },
        getMetricValue(propertyName) {
            if (this.value && this.value.metricConfig) {
                return this.value.metricConfig[propertyName];
            }

            return null;
        },
    }
}
</script>